export default "__VITE_ASSET__d3c67e38__"